import { apiClient } from '../../plugins/api'
import {
    GAME_STATUS_REQUEST,
    GAME_STATUS_SUCCESS,
    GAME_DOWNLOAD_VALUABLE_REQUEST,
} from '../actions/game'

const state = {
    status: null,
};

const getters = {
};

const actions = {
    async [GAME_STATUS_REQUEST] ({ commit }) {
        const response = await apiClient().get('/game/status');
        commit(GAME_STATUS_SUCCESS, response.data);
    },
    async [GAME_DOWNLOAD_VALUABLE_REQUEST] ({ dispatch }) {
        const { data } = await apiClient().get('/game/download-valuable');
        dispatch(GAME_STATUS_REQUEST);
        return data.link;
    },
};

const mutations = {
    [GAME_STATUS_SUCCESS] (state, { status }) {
        state.status = status;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
